import axios from "axios";

    

import {endpointCodes} from '../global/index'; 

export default {

  resendCode(user, headers){
    return axios.post(`/${endpointCodes.post}/reenviar-codigo`, user, headers);
  },

  login(user, headers){
    return axios.post(`/${endpointCodes.post}/login`, user, headers);
  },
  login2(user, headers){
    return axios.post(`/${endpointCodes.post}/login_with`, user, headers);
  },

  getInfoUser(data, headers){
    return axios.post(`/${endpointCodes.post}/info_usr`, data, {headers});
  },



  getAllInfo(option, headers){
    return axios.get(`/${endpointCodes.get}/${option}`, {headers});
  },

  getStatusImage(payload, headers){
    return axios.get(`/${endpointCodes.get}/${payload.option}-img/${payload.image}`, {headers});
  },


  getClientOrden(payload, headers){
    return axios.get(`/${endpointCodes.get}/${payload.option}/${payload.id}`, {headers});
  },
  

  getInfoById(payload, headers){
    return axios.get(`/${endpointCodes.get}/${payload.option}/${payload.id}`, {headers});
  },
  getInfoById2(payload, headers){
    return axios.get(`/${endpointCodes.get}/${payload.option}/${payload.id}/${payload.id2}`, {headers});
  },
  getInfoById3(payload, headers){
    return axios.get(`/${endpointCodes.get}/${payload.option}/${payload.id}/${payload.id2}/${payload.search}`, {headers});
  },
 
  search(data, headers){
    return axios.get(`/${endpointCodes.get}/buscar/${data.normalizedOpt}/${data.search}`, {headers});
  },

  searchById(data, headers){
    return axios.get(`/${endpointCodes.get}/buscar/${data.normalizedOpt}/${data.id}/${data.search}`, {headers});
  },


  getByRestaurant(payload, headers){
    return axios.get(`/${endpointCodes.get}/${payload.option}/${payload.id}`, {headers});
  },

  findByUrl(payload, headers){
    return axios.get(`/${endpointCodes.get}/${payload.option}/${payload.url}`, {headers});
  },


 
  //metodos de eliminar, editar y agregar
  deleteItem(payload,token){
    return axios.delete(`/${endpointCodes.del}/${payload.option}/delete`, {
        data: {
          id:payload.id
        },
        headers: {
          Authorization: token 
        } 
      });
  },
  
  editItem(payload,token){
    let  headers = {
      Authorization: token
    }
    return axios.put(`/${endpointCodes.put}/${payload.option}/update`, payload.item, {headers} );
  },

  editImage(payload,token){
    let  headers = {
      Authorization: token
    }
    return axios.put(`/${endpointCodes.put}/${payload.option}/upload/image/${payload.id}`, payload.item, {headers} );
  },

  addItem(payload,token){
    let  headers = {
      Authorization: token
    }
    return axios.post(`/${endpointCodes.post}/${payload.option}/create`, payload.item, {headers});
  },

  
  enviarMailContacto(data, headers){
    return axios.post(`j43-wdrDE4s_wffs2/contacto`, data, headers);
  },
  
  enviarMailContacto2(data, headers){
    return axios.post(`j43-wdrDE4s_wffs2/contacto-dos`, data, headers);
  },

  enviarMailLanding(data, headers){
    return axios.post(`j43-wdrDE4s_wffs2/contactoLanding`, data, headers);
  },


  

};